import clsx from "clsx";
import { useFormik } from "formik";
import debounce from "lodash/debounce";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import CalendarPicker from "../../../components/CalenderPicker";
import { useClickOutside } from "../../../components/customHooks/useClickOutside";
import Dropdown from "../../../components/Dropdown";
import ImagePicker from "../../../components/ImagePicker";
import { Input } from "../../../components/Input";
import LeftSide from "../../../components/LeftSide";
import ModalAction from "../../../components/ModalAction";
import ModalSkeleton from "../../../components/ModalSkeleton";
import MultiSelectDropdown from "../../../components/MultiSelect";
import PhoneInput from "../../../components/PhoneInput";
import ShowCalculation from "../../../components/ShowCalculation";
import StartAndEndTime from "../../../components/StartAndEndTime";
import UserDropdown from "../../../components/userDropdown";
import {
  BadmintonIcon,
  BookingTypeIcon,
  CorporateIcon,
  DarkMailIcon,
  DiscountIcon,
  InvoiceIcon,
  LocationIcon,
  ReceivePaymentIcon,
  UserOutline,
} from "../../../constant";
import { bookingTypeOptions, paymentMethods } from "../../../data";
import {
  addMinutes,
  convertToAmPm,
  formatNumberWithCommas,
} from "../../../helpers";
import {
  dayOfWeek,
  generateIntervals,
  getCourtTimings,
  getRelatedCourts,
  getSelectedCourt,
  splitAndMarkBlockedIntervals,
} from "../../../lib";
import useApi from "../../../useApi";
import classes from "./AddOrEditBookingModal.module.css";
const durations = [
  { label: "1 Hour", value: 60 },
  { label: "30 Minutes", value: 30 },
];
const CourtDayOfWeekEnum = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

const validationSchema = Yup.object()
  .shape({
    name: Yup.string().required("Name is required"),
    phoneNumber: Yup.string()
      .required("Phone number is required")
      .matches(/^\+?[0-9]{1,4}[0-9]{10}$/, "Invalid phone number format"),
    email: Yup.string().email("Invalid email address"),
    bookingDate: Yup.string().required("Date is required"),
    location: Yup.string().required("Location is required"),
    court: Yup.string().required("Court is required"),
    bookingType: Yup.number().required("Booking type is required"),
    paymentMethod: Yup.string().required("Payment method is required"),
    timeSlots: Yup.array().when(["bookingType"], {
      is: (bookingType) => bookingType === 1 || bookingType === 5,
      then: () => Yup.array().min(1, "At least one time slot must be selected"),
      otherwise: () => Yup.array(),
    }),
    startTime: Yup.mixed().when(["bookingType"], {
      is: (bookingType) => bookingType !== 1 && bookingType !== 5,
      then: () => Yup.mixed().required("Start time is required").nullable(),
      otherwise: () => Yup.mixed().nullable(),
    }),
    endTime: Yup.mixed().when(["bookingType"], {
      is: (bookingType) => bookingType !== 1 && bookingType !== 5,
      then: () => Yup.mixed().required("End time is required").nullable(),
      otherwise: () => Yup.mixed().nullable(),
    }),
    corporateId: Yup.mixed().when("bookingType", {
      is: 5,
      then: () => Yup.number().required("Please select a corporation"),
      otherwise: () => Yup.mixed().nullable(),
    }),
    totalPayment: Yup.number()
      .required("Total payment is required")
      .positive("Total payment must be greater than 0")
      // alternatively, you could use:
      // .min(0.01, 'Total payment must be greater than 0')
      .typeError("Total payment must be a number"),
  })

  .test("time-slots-validation", "", function (value) {
    if (value.bookingType === 1 || value.bookingType === 5) {
      if (!value.timeSlots || value.timeSlots.length === 0) {
        return this.createError({
          path: "timeSlots",
          message: "At least one time slot must be selected",
        });
      }
    } else {
      if (!value.startTime || !value.endTime) {
        return this.createError({
          path: "timeSlots",
          message: "Please select both start and end time",
        });
      }
    }
    return true;
  });

const initialValues = {
  name: "",
  phoneNumber: "",
  email: "",
  location: null,
  court: null,
  bookingType: null,
  bookingDate: moment().format("YYYY-MM-DD"),
  timeSlots: [],
  discountAmount: 0,
  paymentMethod: null,
  totalPayment: "",
  paymentCollection: 0,
  duration: null,
  attachment: null,
  startTime: null,
  endTime: null,
  corporateId: null,
};
const SHOW_SEARCHING_FIELDS = { name: false, phoneNumber: false, email: false };
const AddOrEditBookingModal = ({
  show,
  setShow,
  onSubmit,
  isApiCall,
  data,
  newBooking,
}) => {
  const [loading, setLoading] = useState(false);
  const [timeSlots, setTimeSlots] = useState([]);
  const [blockedSlots, setBlockedSlots] = useState([]);
  let { locations } = useSelector((state) => state?.allPreLoadedApis);
  const [userList, setUserList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showUserDropdown, setShowUserDropdown] = useState(
    SHOW_SEARCHING_FIELDS
  );
  const [readonly, setReadonly] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);
  const { getAllBlockedSlots, getUserByName, getAllCorporates } = useApi();
  const [userSelected, setUserSelected] = useState(false);
  const [corporateOptions, setCorporateOptions] = useState([]);
  const [isLoadingCorporates, setIsLoadingCorporates] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  console.log("Locations", locations);
  const getAllSlotsApi = async (date, courtId) => {
    setLoading(true);

    const response = await getAllBlockedSlots({
      companyDetailID: 1,
      courtId: courtId,
      date,
    });
    if (response?.data?.headers?.error === 200) {
      console.log("data blocked slots", response?.data?.body?.items);
      setBlockedSlots(response?.data?.body?.items);
      return response?.data?.body?.items;
    }
    if (response?.data?.headers?.error !== 200) {
      toast.error(response?.data?.headers?.message);
    }
  };

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce(async (name, term) => {
      if (term.length < 2) {
        setUserList([]);
        // Don't hide dropdown here, let the input change handler do it
        return;
      }

      setSearchLoading(true);
      try {
        await getUserByNameApi(term);
        setShowUserDropdown((prev) => ({ ...prev, [name]: true }));
      } catch (error) {
        console.error("Error searching users:", error);
        toast.error("Failed to search users");
      } finally {
        setSearchLoading(false);
      }
    }, 500),
    []
  );

  const getUserByNameApi = async (params) => {
    const response = await getUserByName({
      id: null,
      search: params,
      pageNumber: 1,
      pageSize: 100000, // Limit to 10 results for better performance
      showInactive: true,
      showUpcoming: true,
    });

    if (response?.data?.headers?.error === 200) {
      setUserList(response?.data?.body?.items || []);
    }
  };

  const fetchCorporates = async () => {
    setIsLoadingCorporates(true);
    try {
      const response = await getAllCorporates({
        search: "",
        pageNumber: 1,
        pageSize: 100,
      });

      if (response?.data?.headers?.error === 200) {
        const corporateList = response?.data?.body?.items || [];
        // Transform into dropdown options
        setCorporateOptions(corporateList);
      }
    } catch (error) {
      console.error("Error fetching corporations:", error);
      toast.error("Failed to load corporations");
    } finally {
      setIsLoadingCorporates(false);
    }
  };

  useEffect(() => {
    if (show) {
      fetchCorporates();
    }
  }, [show]);

  const getCombinedBookingOptions = () => {
    // Base options always visible
    const baseOptions = [
      { label: "Standard", value: 1 },
      { label: "Corporate", value: 2 },
    ];

    return bookingTypeOptions;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      // If Corporate booking type is selected but no corporation is chosen, show error
      if (values.bookingType === 5 && !values.corporateId) {
        setFieldError("corporateId", "Please select a corporation");
        setFieldTouched("corporateId", true);
        setSubmitting(false);
        return; // Don't proceed with submission
      }

      console.log("values", values);
      const params = {
        playerName: values?.name,
        playerCellNumber: values?.phoneNumber?.slice(2),
        playerCountryCode: `+${values?.phoneNumber?.slice(0, 2)}`,
        playerEmail: values?.email,
        paymentModeId: values?.paymentMethod,
        bookingTypeId: values?.bookingType,
        corporateId: values?.corporateId || null,
        teamLevel: 0,
        teamTypeId: null,
        courtId: values?.court,
        bookingDate: values?.bookingDate,
        bookingTimes:
          (values?.bookingType === 1 || values?.bookingType === 5) &&
          !newBooking
            ? values?.timeSlots?.map((data) => {
                const [startTime, endTime] = data
                  ?.split("-")
                  ?.map((time) => time?.trim());
                return {
                  bookingStartTime: startTime,
                  bookingEndTime: endTime,
                };
              })
            : [
                {
                  bookingStartTime: moment(values.startTime).format("HH:mm:ss"),
                  bookingEndTime: moment(values.endTime).format("HH:mm:ss"),
                },
              ],
        totalAmount: +values?.totalPayment,
        discountAmount: values?.discountAmount,
        collectedAmount: values?.paymentCollection,
        attachment: values?.attachment,
      };
      if (typeof onSubmit === "function") {
        onSubmit(params);
      }
    },
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateField,
  } = formik;
  let calculatedAmount = values?.totalPayment - values?.discountAmount || "";
  let remainingPayment = values?.totalPayment || 0;
  if (calculatedAmount < 0) calculatedAmount = "";
  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };

  const derivedDurationFromCourts = (e) => {
    if (!e) return;

    const selectedCourt = getSelectedCourt(values?.location, e);
    if (!selectedCourt?.courtSlotDuration) return;

    const duration = durations?.find(
      (duration) => duration?.value === selectedCourt?.courtSlotDuration
    );

    if (duration?.value) {
      setFieldValue("duration", duration.value);
    }
  };

  const handleCourtChange = (e) => {
    if (!e) return;

    // Set value first
    setFieldValue("court", e);
    derivedDurationFromCourts(e);

    // Reset dependent fields
    setFieldValue("timeSlots", []);
    setFieldValue("totalPayment", 0);
  };

  let firstTime = 0;

  console.log("values?.court", values?.court);
  useEffect(() => {
    if (values?.duration && firstTime === 0) {
      firstTime = 1;
      setTimeSlots((prev) =>
        prev?.map((data) => ({
          label: `${convertToAmPm(data?.label?.split("-")[0])} - ${addMinutes(
            data?.label?.split("-")[0],
            values?.duration
          )}`,
          value: data?.value,
          ...data,
        }))
      );
    }

    console.log("errors ()", errors);
    if (values?.duration && values?.bookingDate && values?.court) {
      (async () => {
        const allRelatedTiming = getCourtTimings(
          values?.location,
          values?.court,
          dayOfWeek(values?.bookingDate)
        );

        const blockedAllSlots = await getAllSlotsApi(
          moment(values?.bookingDate)?.format("YYYY-MM-DD"),
          values?.court
        );

        const allPossibleInterval = generateIntervals(
          allRelatedTiming,
          values?.duration,
          getSelectedCourt(values?.location, values?.court)?.courtSlotDuration
        );

        const splittedResult = splitAndMarkBlockedIntervals(
          allPossibleInterval,
          blockedAllSlots
        );
        console.log("allPossibleInterval", allPossibleInterval);
        console.log("blockedSlots", blockedAllSlots);
        console.log("splittedResult", splittedResult);
        setTimeSlots(
          splittedResult
            ?.filter((slot) => !slot?.isBlocked)
            ?.map((slot) => ({
              label: `${convertToAmPm(slot?.courtStartTime)} - ${convertToAmPm(
                slot?.courtEndTime
              )}`,
              value: `${slot?.courtStartTime} - ${slot?.courtEndTime}`,
              ...slot,
            }))
        );
      })();
    }
  }, [values?.duration, values?.bookingDate, values?.court]);

  useEffect(() => {
    setFieldValue("paymentMethod", paymentMethods[0]?.value);
    setFieldValue("bookingType", bookingTypeOptions[0]?.value);
    setFieldValue("duration", durations[0]?.value);
    setFieldValue("timeSlots", []); // Initialize timeSlots as empty

    console.log("store", "locations", locations);

    if (locations?.length == 1) {
      setFieldValue("location", locations[0]?.locationId);
    }
  }, []);

  useEffect(() => {
    // Add this useEffect to handle bookingType changes
    if (values?.bookingType !== 1 && values?.bookingType !== 5) {
      setFieldValue("timeSlots", []);
      setFieldValue("totalPayment", 0);
      setTimeSlots([]); // Reset the available time slots
    }
  }, [values?.bookingType]);

  const handleTimeChange = (type, time) => {
    console.log("type", type, "time", time);

    if (type === "start") {
      setFieldValue("startTime", time);
      setFieldTouched("startTime", true, true);
      if (values.endTime) {
        const startStr = moment(time).format("HH:mm:ss");
        const endStr = moment(values.endTime).format("HH:mm:ss");
        handleChangeWithTouch("timeSlots")([`${startStr}-${endStr}`]);
        // Clear timeSlots error when both times are selected
        setFieldTouched("timeSlots", true, true);
        setFieldError("timeSlots", undefined);
      }
    } else {
      setFieldValue("endTime", time);
      setFieldTouched("endTime", true, true);
      if (values.startTime) {
        const startStr = moment(values.startTime).format("HH:mm:ss");
        const endStr = moment(time).format("HH:mm:ss");
        handleChangeWithTouch("timeSlots")([`${startStr}-${endStr}`]);
        // Clear timeSlots error when both times are selected
        setFieldTouched("timeSlots", true, true);
        setFieldError("timeSlots", undefined);
      }
    }
  };

  console.log("errors add booking", errors);

  // Handle name input change
  const handleNameChange = (name, value) => {
    setFieldValue(name, value);
    setFieldTouched(name, false);
    setSearchTerm(value);

    // Only hide dropdown if the input is cleared
    if (!value || value.trim() === "") {
      setShowUserDropdown({ ...SHOW_SEARCHING_FIELDS });
    } else {
      debouncedSearch(name, value);
    }
  };

  // Handle user selection from dropdown
  const handleUserSelect = (name, user) => {
    console.log("User", user);
    if (user?.userFullName) setFieldValue("name", user.userFullName || "");

    // Format and set phone number if available
    if (user.cellNumber) {
      // First, clean the phone number by removing any non-digit characters
      let phoneDigits = user.cellNumber.replace(/\D/g, "");

      // Check if we need to add a default country code
      if (phoneDigits.length < 12) {
        // Assuming Pakistan country code (92) if not present
        if (!phoneDigits.startsWith("92")) {
          phoneDigits = "92" + phoneDigits;
        }
      }

      // Set the properly formatted phone number
      setFieldValue("phoneNumber", phoneDigits);
      setFieldTouched("phoneNumber", false);
      setTimeout(() => {
        setFieldTouched("phoneNumber", true);
      }, 50);
    }

    // Set email if available
    if (user?.email) {
      setFieldValue("email", user?.email);
      setFieldTouched("email", true);
    }
setFieldValue("isSignup",user.isSignup)
    setShowUserDropdown({ ...SHOW_SEARCHING_FIELDS });
    setUserSelected(true);
  };

  // Add a function to reset user selection
  const resetUserSelection = () => {
    setFieldValue("name", "");
setFieldValue("isSignup",false)
    setFieldValue("phoneNumber", "");
    setFieldValue("email", "");
    setUserSelected(false);
    setFieldTouched("name", false);
    setFieldTouched("phoneNumber", false);
    setFieldTouched("email", false);
  };

  useEffect(() => {
    if (data) {
      console.log("Data in inside AddOrEditBookingModal", data);
      setFieldValue(
        "bookingDate",
        moment(data?.bookingDate).format("YYYY-MM-DD")
      );
      setFieldValue("court", data?.courtId);
      setFieldValue("location", data?.locationId);
      console.log(
        "getCourtsRelatedToLocation",
        getRelatedCourts(data?.locationId)
      );
      setFieldValue("duration", data?.duration);
      setFieldValue("timeSlots", [data?.value]);
      setFieldValue("totalPayment", data?.courtCharges?.toFixed(0));
      // setFieldValue("court", courtId);
      // Format time values for StartAndEndTime
      if (data?.startTime) {
        const startTime = moment(data?.startTime, "HH:mm:ss").toDate();
        setFieldValue("startTime", startTime);
      }

      if (data?.endTime) {
        const endTime = moment(data?.endTime, "HH:mm:ss").toDate();
        setFieldValue("endTime", endTime);
      }

      if (data?.bookingType) {
        setFieldValue("bookingType", data?.bookingType);
      }

      // Clear error if time slots are selected
    }
  }, [data]);

  // Add this function to handle keyboard navigation
  const handleSearchInputKeyDown = (e) => {
    // Only process keyboard events when dropdown is open
    if (!showUserDropdown) return;

    const userCount = userList.length;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setHighlightedIndex((prev) => (prev < userCount - 1 ? prev + 1 : 0));
        break;

      case "ArrowUp":
        e.preventDefault();
        setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : userCount - 1));
        break;

      case "Enter":
        e.preventDefault();
        if (highlightedIndex >= 0 && highlightedIndex < userCount) {
          // Select the highlighted user
          console.log("");
          console.log("UserList..", userList);
          handleUserSelect("name", userList[highlightedIndex]);
          setShowUserDropdown({ ...SHOW_SEARCHING_FIELDS });
          setHighlightedIndex(-1);
        }
        break;
      case "Escape":
        e.preventDefault();
        setShowUserDropdown({ ...SHOW_SEARCHING_FIELDS });
        setHighlightedIndex(-1);
        break;

      default:
        break;
    }
  };

  // Modify the useEffect where you handle clicking outside to reset highlighted index

  const handleClickOutside = () => {
    setShowUserDropdown({ ...SHOW_SEARCHING_FIELDS });
    setHighlightedIndex(-1);
  };
  const userDropdownRef = useClickOutside(handleClickOutside);
  const phoneDropdownRef = useClickOutside(handleClickOutside);
  const emailDropdownRef = useClickOutside(handleClickOutside);
  // Reset highlighted index when search results change
  useEffect(() => {
    setHighlightedIndex(-1);
  }, [userList]);

  const shouldUseStartAndEndTime = () => {
    // If newBooking is true, always use StartAndEndTime
    if (newBooking) return true;

    // For existing bookings, use StartAndEndTime for non-standard booking types
    return values?.bookingType !== 1 && values?.bookingType !== 5;
  };

  return (
    <>
      <ModalSkeleton
        width="900px"
        show={show}
        setShow={setShow}
        title={"Add Booking"}
      >
        <form onSubmit={handleSubmit} className={classes.form}>
          <Row className={classes.controlGrid}>
            <Col md={6}>
              <div className={classes.searchInputContainer}>
                <Input
                  type="text
                "
                  leftIcon={
                    <LeftSide icon={<UserOutline className={classes.icon} />} />
                  }
                  customStyle={{ gap: "15px" }}
                  inputStyle={{ paddingLeft: "0" }}
                  labelStyle={{ fontSize: "16px" }}
                  label="Name"
                  placeholder="Enter name"
                  value={values?.name}
                  onChange={
                    (e) => { 
                          handleNameChange("name", e);
                        }
                    
                  }
                  disabled={values.isSignup}
                  // disabled={userSelected}
                  errorText={touched?.name && errors?.name}
                  list="your-datalist-id"
                  readOnly={readonly}
                  onFocus={() => setReadonly(false)}
                  autoComplete="new-password"
                  autoCorrect="off"
                  autoCapitalize="off"
                  rightIcon={
                    userSelected && (
                      <button
                        type="button"
                        className={classes.editUserButton}
                        onClick={resetUserSelection}
                        title="Remove user information"
                      >
                        <RxCross2 className={classes.editIcon} />
                      </button>
                    )
                  }
                  onKeyDown={handleSearchInputKeyDown}
                />
                <UserDropdown
                  ref={userDropdownRef}
                  show={showUserDropdown.name}
                  users={userList}
                  loading={searchLoading}
                  highlightedIndex={highlightedIndex}
                  onSelect={(e) => handleUserSelect("name", e)}
                />
                {/* {showUserDropdown && userList.length > 0 && (
                  <div ref={userDropdownRef} className={classes.userDropdown}>
                    {searchLoading ? (
                      <div className={classes.dropdownLoading}>Loading...</div>
                    ) : (
                      userList.map((user, index) => (
                        <div
                          key={user.userDetailId}
                          className={`${classes.userOption} ${
                            index === highlightedIndex
                              ? classes.highlighted
                              : ""
                          }`}
                          onClick={() => handleUserSelect(user)}
                        >
                          <div className={classes.userName}>
                            {user.playerFullName}
                          </div>
                          <div className={classes.userPhone}>
                            <span> {user.userFullName}</span>
                            <span>{user.cellNumber}</span>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                )} */}
              </div>
            </Col>
            <Col md={6}>
              <div className={classes.searchInputContainer}>
                <PhoneInput
                  labelStyle={{ fontSize: "16px" }}
                  label={"Phone Number"}
                  placeholder="Enter Phone Number"
                  value={values?.phoneNumber}
                  onChange={
                    userSelected
                      ? undefined
                      : (e) => {
                          handleNameChange("phoneNumber", e);
                        }
                  }
                  disabled={userSelected}
                  errorText={touched?.phoneNumber && errors?.phoneNumber}
                  onKeyDown={handleSearchInputKeyDown}
                />
              </div>
              <UserDropdown
                ref={phoneDropdownRef}
                show={showUserDropdown.phoneNumber}
                users={userList}
                loading={searchLoading}
                highlightedIndex={highlightedIndex}
                onSelect={(e) => handleUserSelect("phoneNumber", e)}
              />
            </Col>
            <Col md={6}>
              <div className={classes.searchInputContainer}>
                <Input
                  isOptional={true}
                  leftIcon={<LeftSide icon={<DarkMailIcon />} />}
                  customStyle={{ gap: "15px" }}
                  inputStyle={{ paddingLeft: "0" }}
                  type="email"
                  labelStyle={{ fontSize: "16px" }}
                  label={"Email"}
                  placeholder="Enter Email"
                  value={values?.email}
                  onChange={
                    userSelected
                      ? undefined
                      : (e) => {
                          handleNameChange("email", e);
                        }
                  }
                  disabled={userSelected}
                  errorText={touched?.email && errors?.email}
                  readOnly={readonly}
                  onFocus={() => setReadonly(false)}
                  autoComplete="new-password"
                  autoCorrect="off"
                  autoCapitalize="off"
                />
                <UserDropdown
                  ref={emailDropdownRef}
                  show={showUserDropdown.email}
                  users={userList}
                  loading={searchLoading}
                  highlightedIndex={highlightedIndex}
                  onSelect={(e) => handleUserSelect("email", e)}
                />
              </div>
            </Col>
            {locations?.length > 1 && (
              <Col md={6}>
                <Dropdown
                  options={locations?.map((data) => ({
                    label: data?.locationName,
                    value: data?.locationId,
                  }))}
                  icon={<LeftSide icon={<LocationIcon />} />}
                  customStyle={{ gap: "4px" }}
                  inputStyle={{ paddingLeft: "0" }}
                  labelStyle={{ fontSize: "16px" }}
                  label={"Location"}
                  placeholder="Select Location"
                  value={values?.location}
                  onChange={handleChangeWithTouch("location")}
                  errorText={touched?.location && errors?.location}
                />
              </Col>
            )}
            <Col md={6}>
              <Dropdown
                options={getRelatedCourts(values?.location)?.filter(
                  (court) => court?.courtStatusId !== 2
                )}
                icon={
                  <LeftSide
                    icon={<BadmintonIcon className={classes.leftIcon} />}
                  />
                }
                customStyle={{ gap: "4px" }}
                inputStyle={{ paddingLeft: "0" }}
                type="number"
                labelStyle={{ fontSize: "16px" }}
                label={"Court"}
                placeholder="Select Court"
                value={values?.court}
                onChange={handleCourtChange}
                errorText={
                  touched?.court && !values?.court ? errors?.court : undefined
                }
              />
            </Col>

            <Col md={6}>
              <Dropdown
                options={getCombinedBookingOptions()}
                icon={
                  <LeftSide
                    icon={<BookingTypeIcon className={classes.leftIcon} />}
                  />
                }
                label={"Booking Type"}
                placeholder="Select Booking Type"
                value={values?.bookingType}
                onChange={(e) => {
                  setFieldValue("timeSlots", []);
                  setFieldValue("startTime", null);
                  setFieldValue("endTime", null);
                  setFieldValue("bookingType", e);
                  setFieldValue("totalPayment", "");
                  // If switching to corporate type, clear corporateId and mark as untouched
                  if (e === 5) {
                    setFieldValue("corporateId", null);
                    setFieldTouched("corporateId", false);
                  } else {
                    // When changing away from corporate, reset corporateId
                    setFieldValue("corporateId", null);
                  }
                }}
                errorText={touched?.bookingType && errors?.bookingType}
              />
            </Col>

            {/* Conditional Corporate Dropdown */}
            {values?.bookingType === 5 && (
              <Col md={6}>
                <div className={classes.corporateDropdownContainer}>
                  <Dropdown
                    icon={
                      <LeftSide
                        icon={<CorporateIcon className={classes.leftIcon} />}
                      />
                    }
                    label={"Select Corporation"}
                    options={corporateOptions.map((corp) => ({
                      label: corp.corporateName,
                      value: corp.corporateId,
                    }))}
                    value={values?.corporateId}
                    onChange={(e) => {
                      setFieldValue("corporateId", e);
                      // Delay marking as touched to allow validation to update first
                      setTimeout(() => {
                        setFieldTouched("corporateId", true, true); // The third parameter forces validation
                      }, 100);
                    }}
                    placeholder="Choose a Corporate"
                    errorText={touched?.corporateId && errors?.corporateId}
                  />
                  {values?.bookingType === 5 &&
                    !values?.corporateId &&
                    !touched?.corporateId && (
                      <div className={classes.requiredFieldNote}>
                        Required field
                      </div>
                    )}
                </div>
              </Col>
            )}

            <Col md={6}>
              <CalendarPicker
                label={"Booking Date"}
                placeholder="Select Booking Date"
                labelStyle={{ fontSize: "16px" }}
                value={values?.bookingDate}
                onChange={(e) => {
                  // Reset time-related fields when date changes
                  setFieldValue("timeSlots", []);
                  setFieldValue("startTime", null);
                  setFieldValue("endTime", null);
                  setFieldValue("totalPayment", 0);
                  handleChangeWithTouch("bookingDate")(
                    moment(e).format("YYYY-MM-DD")
                  );
                }}
                errorText={touched?.bookingDate && errors?.bookingDate}
                dateFormat="dd M `y"
              />
            </Col>
            <Col md={6}>
              {shouldUseStartAndEndTime() ? (
                <StartAndEndTime
                  label={"Time Slot"}
                  labelStyle={{ fontSize: "16px" }}
                  isOptional={true}
                  disabled={!values?.court || !values?.bookingDate}
                  onChange={handleTimeChange}
                  startTime={values?.startTime}
                  endTime={values?.endTime}
                  reset={!values?.court || !values?.bookingDate}
                  errors={{
                    startTime: touched?.startTime && errors?.startTime,
                    endTime: touched?.endTime && errors?.endTime,
                  }}
                />
              ) : (
                <Row>
                  <Col md={7}>
                    <MultiSelectDropdown
                      display="comma"
                      options={timeSlots}
                      labelStyle={{ fontSize: "16px" }}
                      label="Time Slot"
                      placeholder="Select Time Slot"
                      selectionMode="multiple"
                      disabled={!values?.bookingDate}
                      value={values?.timeSlots}
                      filter={true}
                      filterPlaceholder="Search"
                      emptyFilterMessage="No matching time slots"
                      onChange={(selectedValues) => {
                        console.log("Selected values:", selectedValues);
                        let dayOfWeek = new Date(values?.bookingDate).getDay();
                        let dayName = Object.keys(CourtDayOfWeekEnum).find(
                          (day) => CourtDayOfWeekEnum[day] === dayOfWeek
                        );
                        const totalCharges = timeSlots
                          ?.filter((data) =>
                            selectedValues.includes(data?.value)
                          )
                          .reduce((sum, item) => sum + item.courtCharges, 0);

                        handleChangeWithTouch("timeSlots")(selectedValues);
                        handleChangeWithTouch("totalPayment")(
                          totalCharges?.toFixed(0)
                        );

                        // Clear error if time slots are selected
                        if (selectedValues && selectedValues.length > 0) {
                          setFieldError("timeSlots", undefined);
                        }
                      }}
                    />
                  </Col>
                  <Col md={5} className={clsx("ps-0", classes.duration)}>
                    <Dropdown
                      options={durations}
                      isOptional={true}
                      label={"     "}
                      placeholder="Select Duration"
                      value={values?.duration}
                      onChange={(e) => {
                        setFieldValue("timeSlots", null);
                        handleChangeWithTouch("totalPayment")(0);
                        handleChangeWithTouch("duration")(e);
                      }}
                    />
                  </Col>
                </Row>
              )}

              {errors?.timeSlots && touched?.timeSlots && (
                <Col md={12}>
                  <p className={"errorText"}>
                    {shouldUseStartAndEndTime()
                      ? !values?.startTime || !values?.endTime
                        ? errors?.timeSlots
                        : ""
                      : values?.timeSlots?.length === 0
                      ? errors?.timeSlots
                      : ""}
                  </p>
                </Col>
              )}
            </Col>

            <Col md={6}>
              <Input
                isOptional={true}
                customStyle={{ gap: "4px" }}
                inputStyle={{ paddingLeft: "0" }}
                type="number"
                leftIcon={<LeftSide icon={<DiscountIcon />} right={"Rs."} />}
                labelStyle={{ fontSize: "16px" }}
                label={"Discount"}
                placeholder="Enter Discount"
                value={values?.discountAmount}
                onChange={(e) => {
                  console.log("discountAmount", e);
                  console.log("+calculatedAmount", +calculatedAmount);
                  if (+e > +calculatedAmount) {
                    toast.warn(
                      "Discount amount should be less than or equal to total payment"
                    );
                    return;
                  } else {
                    handleChangeWithTouch("discountAmount")(e);
                  }
                  // handleChangeWithTouch("discountAmount")(e);
                }}
              />
            </Col>
            <Col md={6}>
              <Dropdown
                icon={
                  <InvoiceIcon
                    className={clsx(classes.leftIcon, classes.iconSize)}
                  />
                }
                options={paymentMethods?.filter((data) => data?.value !== 0)}
                labelStyle={{ fontSize: "16px" }}
                label={"Payment Mode"}
                placeholder="Select Payment Mode"
                value={values?.paymentMethod}
                onChange={handleChangeWithTouch("paymentMethod")}
                errorText={touched?.paymentMethod && errors?.paymentMethod}
              />
            </Col>

            <Col md={6}>
              <Input
                isOptional={true}
                customStyle={{ gap: "4px" }}
                inputStyle={{ paddingLeft: "0" }}
                type="number"
                disabled={values?.bookingType === 1}
                leftIcon={
                  <LeftSide
                    disabled={true}
                    icon={
                      <ReceivePaymentIcon
                        className={clsx(classes.leftIcon, classes.iconSize)}
                      />
                    }
                    right={"Rs."}
                  />
                }
                labelStyle={{ fontSize: "16px" }}
                label={"Total Payment"}
                placeholder="Enter Total Payment"
                value={calculatedAmount}
                onChange={(e) => {
                  if (+e > +calculatedAmount && values?.bookingType === 1) {
                    handleChangeWithTouch("totalPayment")(0);
                    toast.warn(
                      "Discount amount should be less than total payment"
                    );
                    return;
                  } else {
                    handleChangeWithTouch("totalPayment")(e);
                  }
                }}
                errorText={touched?.totalPayment && errors?.totalPayment}
              />
              <ShowCalculation
                label={"Remaining Payment"}
                value={`Rs. ${formatNumberWithCommas(remainingPayment)}`}
              />
            </Col>
            <Col md={6}>
              <Input
                isOptional={true}
                customStyle={{ gap: "4px" }}
                inputStyle={{ paddingLeft: "0" }}
                type="number"
                // disabled={true}
                leftIcon={
                  <LeftSide
                    // disabled={true}
                    icon={
                      <ReceivePaymentIcon
                        className={clsx(classes.leftIcon, classes.iconSize)}
                      />
                    }
                    right={"Rs."}
                  />
                }
                labelStyle={{ fontSize: "16px" }}
                label={"Payment Collection"}
                placeholder="Enter Collected Amount"
                value={values?.paymentCollection}
                onChange={(e) => {
                  const inputAmount = Number(e);
                  console.log("inputAmount", inputAmount, "ee", e);
                  const maxAllowed =
                    values?.totalPayment - values?.discountAmount;
                  if (inputAmount > maxAllowed) {
                    toast.warn(
                      "Payment Collection should be less than total payment"
                    );
                    return;
                  } else {
                    handleChangeWithTouch("paymentCollection")(inputAmount);
                  }
                }}
              />
            </Col>
            {values?.paymentCollection > 0 && (
              <Col xs={12}>
                <ImagePicker
                  name="image"
                  onChange={(e) => {
                    console.log("attachment", e);
                    setFieldValue("attachment", e);
                  }}
                />
              </Col>
            )}
          </Row>
          <ModalAction
            isApiCall={isApiCall}
            onCancel={() => {
              if (typeof setShow === "function") {
                setShow(false);
              }
            }}
            type="submit"
          />
        </form>
      </ModalSkeleton>
    </>
  );
};

export default AddOrEditBookingModal;
